import Api from '../../../api/article/articleDefinition';

export default {
  namespaced: true,
  state: {
    validTestPigs: [],
    loading: false,
    code: ''
  },
  mutations: {
    setValidTestPigs(state, data) {
      state.validTestPigs = data;
      state.loading = false;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setCode(state, value) {
      state.code = value;
    }
  },
  actions: {
    async validate({commit}, { model}) {
      try {
        commit('setLoading', true);
        const response = await Api.validate(model);
        commit('setValidTestPigs', response.data);
        return Promise.resolve(response.data);
      } catch(error) {
        return Promise.reject(error);
      }
    },
    async save({dispatch}, { model}) {
      try {
        const response = await Api.create(model);
        dispatch('NOTIFY_MSG', 'article.notification.saveCode',
          { root: true});
        return Promise.resolve(response.data);
      } catch(error) {
        return Promise.reject(error);
      }
    },
    async fetch({dispatch, commit}, { id}) {
      try {
        const response = await Api.fetch(id);

        if(response.data) {
          commit('setCode', response.data.code);
        }

        return Promise.resolve(response.data);
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
      }
    },
  }
}
